import { createContext } from "react";

export const FilterInfo = createContext();